(function () {
    'use strict';
    var controllerId = 'testShow';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$uibModalInstance', 'datacontext', "common", 'pacchettoId', 'testIndex', testShow]);

    function testShow($rootScope, $scope, $uibModalInstance, datacontext, common, pacchettoId, testIndex) {
        $scope.pacchettoId = pacchettoId;
        $scope.item = {};
        $scope.item.tests = [];
        $scope.item.test = {};
        $scope.item.anteprime = [];
        $scope.item.questions = [];

        $scope.indexTest = testIndex;
        $scope.preview = 0;

        getListTest();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.getTest = function (index, current) {
            $scope.indexTest = index;
            $scope.changeMainMedia(index, current);
            $scope.item.test = getTest($scope.item.tests[index].TestId);            
        };

        function getListTest() {
            return datacontext.pacchettoTest_getAllByPacchetto($scope.pacchettoId, 'titolo').then(function (data) {
                $scope.item.tests = data;
                $scope.item.test = getTest(data[$scope.indexTest].TestId);
            });
        }

        function getTest(id) {
            return datacontext.stak_test_get(id).then(function (data) {
                if (data) {                    
                    data.questions = [];
                    $scope.item.test = data;
                    $scope.preview = 0;
                    getListAnteprime(id);

                    //datacontext.tipoTest_get(data.tipoTestId).then(function (data) {
                    //    if (data)
                    //        $scope.item.test.tipoTest = data.Title;
                    //});
                }
            });
        }        

        function getListAnteprime(id) {
            if (!id) return;

            $scope.item.anteprime = [];
            return datacontext.testAnteprime_getAllByTest(id, 0).then(function (data) {     
                if (data && data.length > 0) {
                    data.forEach(function (q) {
                        q.qPath = q.Path;
                        q.rPath = q.PathRisposta;
                        q.showRisposta = false;
                    });
                }

                return $scope.item.anteprime = data;
            });
        }        

        $scope.nextTest = function (index, current) {
            var check = $scope.indexTest + 1;
            if (check < $scope.item.tests.length)
                $scope.indexTest++;
            else
                $scope.indexTest = 0;

            $scope.changeMainMedia(index, current);
            $scope.item.test = getTest($scope.item.tests[$scope.indexTest].TestId);
        };

        $scope.previousTest = function (index, current) {
            var check = $scope.indexTest - 1;
            if (check >= 0)
                $scope.indexTest--;
            else
                $scope.indexTest = $scope.item.tests.length - 1;

            $scope.changeMainMedia(index, current);
            $scope.item.test = getTest($scope.item.tests[$scope.indexTest].TestId);
        };

        $scope.setPreview = function (index) {
            $scope.preview = index;
            $scope.item.anteprime.forEach(function (o) {
                o.showRisposta = false;
                o.Path = o.qPath;
            });
        };

        $scope.toggleRisposte = function (item) {
            item.showRisposta = !item.showRisposta;

            if (item.showRisposta)
                item.Path = item.rPath;
            else
                item.Path = item.qPath;
        };

        $scope.current1 = 0;
        $scope.current2 = 0;

        $scope.changeMainMedia = function (index, key) {
            $scope[key] = index;
            var item = document.getElementById("thumbs").getElementsByTagName("li");
            $scope.scroll(item[$scope.indexTest]);
        };

        // Animate scrolling
        $scope.scrollTo = function (element, to, duration) {
            if (duration <= 0)
                return;
            var difference = to - element.scrollLeft;
            var perTick = difference / duration * 10;

            setTimeout(function () {
                element.scrollLeft = element.scrollLeft + perTick;
                if (element.scrollLeft === to)
                    return;
                $scope.scrollTo(element, to, duration - 10);
            }, 10);
        };

        // calculate scroll position and starting scroll animation
        $scope.scroll = function (element) {
            // Get center of parent
            var left = element.offsetLeft;

            var scroll = left - element.parentElement.scrollLeft;

            // Start scroll
            $scope.scrollTo(element.parentElement, scroll, 300);
        };        
    }
})();